import { FunctionComponent, PropsWithChildren } from 'react'

import Map, { Result } from '../Map'
import AdventureCallout from './AdventureCallout'

type MarkerCalloutProps = {
  type: 'Listing' | 'Adventure'
}

const MarkerCallout: FunctionComponent<PropsWithChildren<
  MarkerCalloutProps
>> = ({ type, ...props }) => {
  switch (type) {
    case 'Adventure':
      return <AdventureCallout {...props} />
    case 'Listing':
      return <>{props.children}</>
    default:
      return null
  }
}

export type ListingPopupData = {
  id: number | string
  location: {
    lat: number
    lng: number
  }
  listing_type: {
    slug: string
  }
  listing_subcategory?: {
    slug: string
  }
}

type ListingResult = Result & {
  listing: ListingPopupData
}

type AdventureResult = Result & {
  adventure: Omit<GQL_AdventureCardFragmentFragment, 'url'>
}

type ListingMapProps = {
  listing?: ListingResult
  adventures?: AdventureResult[]
  analyticsSource: string
  hide?: boolean
}

const ListingMap: FunctionComponent<ListingMapProps> = ({
  listing,
  adventures,
  analyticsSource,
  hide,
}) => {
  if (hide) {
    return null
  }

  const unclustered = listing ? [listing] : []
  const clustered = adventures?.length > 0 ? adventures : []

  return (
    <Map
      unclusteredResults={unclustered}
      results={clustered}
      analyticsSource={analyticsSource}
      PopupComponent={MarkerCallout}
      defaultZoom={10}
      noSearchThisArea
    />
  )
}

export default ListingMap
